import { RoutingFlags } from '@constants/routingFlags';

export const CapacityFinderRoute = {
  path: '/capacity/finder',
  load: () => import('./CapacityFinder'),
  protected: true,
  routingFlag: RoutingFlags.V4CapacityFinder,
};
